document.addEventListener("DOMContentLoaded", async function () {
  // // Check if the Shoplift script is already loaded
  // if (typeof window.shoplift !== "undefined") {
  //   const VARIANT_1_ID = "01a01363-76b1-7aee-b10d-84f54eeb3b5e";
  //   const VARIANT_2_ID = "01a01363-7b86-7b27-b1be-3533c772a02f";
  //   if (window.shoplift.isHypothesisActive) {
  //     const isVariant1Active =
  //       await window.shoplift.isHypothesisActive(VARIANT_1_ID);
  //     const isVariant2Active =
  //       await window.shoplift.isHypothesisActive(VARIANT_2_ID);
  //     if (isVariant1Active) {
  //       // console.log("Variant 1 is active");
  //       await setShopliftCartAttribute(VARIANT_1_ID);
  //     } else if (isVariant2Active) {
  //       // console.log("Variant 2 is active");
  //       await setShopliftCartAttribute(VARIANT_2_ID);
  //     } else {
  //       // console.log("No variant is active");
  //     }
  //   }
  // }
});

async function setShopliftCartAttribute(hypothesisId) {
  if (window?.shopliftHypothesisId !== hypothesisId) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          attributes: {
            shoplift_hypothesis_id: hypothesisId,
          },
        }),
      });
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error("❌ Failed to add Shoplift cart attribute:", error);
    }
  } else if (window?.shopliftHypothesisId === hypothesisId) {
    console.log(
      "Shoplift cart attribute already set to the correct hypothesis ID.",
    );
  }
}
